module.exports = __webpack_public_path__ + "static/media/downArrNavy.9d370572.svg";